import React, { useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import cn from 'classnames';
import { HelpMenu } from 'legacy-packages/ft-cb';
import FAQ from 'legacy-src/components/help/FAQ';
import ButtonWithIcon from 'chameleon/ui-stack/ui/buttons/button-with-icon';
import { withRouter } from 'react-router';

const HelpAndTipsContainer = (props) => {
  const { userData, featureFlag, subjectData, subjectId } = props;
  const { isAdmin, isTeacher, isCoordinator } = userData;
  const {
    preap_quick_tips: preapQuickTipsFlag,
    show_appcues_in_app_help: showAppcuesFlag,
  } = featureFlag;
  const { isPreApSubject } = subjectData;
  const isAdminOrCoordinator = isAdmin || isCoordinator;
  const preapQuickTips = isPreApSubject && preapQuickTipsFlag;
  const showQuickTipsForAtLeastOneProgram =
    showAppcuesFlag && (preapQuickTips || !isPreApSubject);
  const showQuickTips =
    showQuickTipsForAtLeastOneProgram &&
    isTeacher &&
    !isAdminOrCoordinator &&
    !!subjectId;

  const appCues = useRef(null);
  const appCuesParent = useRef(null);
  const quickTipsContainer = useRef(null);

  useEffect(() => {
    if (showQuickTips) {
      appCues.current = document.querySelector('.appcues');

      if (appCues.current) {
        appCuesParent.current = appCues.current.parentElement;
        quickTipsContainer.current.appendChild(appCues.current);

        document.body.classList.add('fauxdal');
      }
    }

    return () => {
      if (showQuickTips && appCuesParent.current) {
        appCuesParent.current.appendChild(appCues.current);
        document.body.classList.remove('fauxdal');
      }
    };
  }, []);

  return (
    <div className="flex justify-end">
      {showQuickTips && (
        <div ref={quickTipsContainer} className="quick-tips mr-4" />
      )}
      <div className={cn({ 'ml-0.8': showQuickTips })}>
        <HelpMenu
          button={
            <ButtonWithIcon
              tabIndex="-1"
              accessibility={{ title: 'Help menu' }}
              icon="question_mark"
            />
          }
          userData={userData}
          subjectData={subjectData}
        >
          <FAQ subjectData={subjectData} isPreAPCoord={isAdminOrCoordinator} />
        </HelpMenu>
      </div>
    </div>
  );
};

const mapStateToProps = ({ userData, featureFlag, subject }) => ({
  userData,
  featureFlag,
  subjectData: subject.data,
});

export default connect(mapStateToProps)(withRouter(HelpAndTipsContainer));
